import React from 'react';
import './AnnouncementBanner.css';

const AnnouncementBanner = () => {
  // Офис уже открыт, баннер больше не нужен
  return null;
};

export default AnnouncementBanner;